/* eslint-disable import/first, import/newline-after-import */

import(/* webpackChunkName: "license-selector-modal", webpackPreload: true */ 'components/resources/show/license-selector-modal/license-selector-modal');
import(/* webpackChunkName: "license-info-modal", webpackPreload: true */ 'components/license/license-info-modal/license-info-modal');
import(/* webpackChunkName: "license-compare-modal", webpackPreload: true */ 'components/license/license-compare-modal/license-compare-modal');
import(/* webpackChunkName: "license-attribution-modal", webpackPreload: true */ 'components/license/license-attribution-modal/license-attribution-modal');
import(/* webpackChunkName: "copy-link", webpackPreload: true */ 'components/util/copy-link/copy-link');

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import(/* webpackChunkName: "copy-link" */ 'components/util/copy-link/copy-link-controller')
  .then((controller) => {
    EezyStimulusApplication.register('copy-link', controller.default);
  });

import(/* webpackChunkName: "license-selector-free-modal-controller" */ 'components/resources/show/license-selector-modal/license-selector-free-modal-controller')
  .then((controller) => {
    EezyStimulusApplication.register('license-selector-free-modal', controller.default);
  });

import(/* webpackChunkName: "license-selector-credit-modal-controller" */ 'components/resources/show/license-selector-modal/license-selector-credit-modal-controller')
  .then((controller) => {
    EezyStimulusApplication.register('license-selector-credit-modal', controller.default);
  });

import(/* webpackChunkName: "license-compare-modal" */ 'components/license/license-compare-modal/license-compare-modal-controller')
  .then((controller) => {
    EezyStimulusApplication.register('license-compare-modal', controller.default);
  });
